<template>
  <transition name="fade">
    <!-- <div class="image-preview-container" v-if="visible" @click.self="closeDialog"> -->
    <div class="image-preview-container" v-if="visible">
      <div class="image-wrapper">
        <img :src="imageUrl" alt="预览图片" class="preview-image" />
        <div class="close-button" @click="closeDialog">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ShowImage',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
    }
  }
}
</script>

<style scoped>
.image-preview-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 添加渐显渐隐效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.image-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: zoom-in 0.3s ease;
}

@keyframes zoom-in {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.preview-image {
  max-width: 80%;
  max-height: 80vh;
  object-fit: contain;
}

.close-button {
  position: absolute;
  bottom: -50px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.close-button i {
  font-size: 20px;
  color: #333;
  /* background-image: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/close_dialog.svg"); */
}

.close-button:hover {
  background-color: rgba(255, 255, 255, 1);
}
</style>